module.exports = __webpack_public_path__ + "img/83.73762dc4.jpg";